module.exports = __webpack_public_path__ + "img/common-file-text-lock.63cf8c10.svg";